import React from 'react';
import { Scale } from 'lucide-react';
import { SEO, breadcrumbs } from '../components/SEO';

export const Terms: React.FC = () => {
  const sections = [
    {
      title: '1. Terms',
      content: 'By accessing our services, you agree to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.'
    },
    {
      title: '2. Use License',
      content: 'Permission is granted to temporarily download one copy of the materials (information or software) for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.',
      list: [
        'Modify or copy the materials',
        'Use the materials for any commercial purpose',
        'Attempt to decompile or reverse engineer any software',
        'Remove any copyright or other proprietary notations',
        'Transfer the materials to another person'
      ],
      listPrefix: 'Under this license you may not:'
    },
    {
      title: '3. Disclaimer',
      content: 'The materials are provided "as is". We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.'
    },
    {
      title: '4. Limitations',
      content: 'In no event shall we or our suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use our services.'
    },
    {
      title: '5. Revisions and Errata',
      content: 'The materials appearing in our services could include technical, typographical, or photographic errors. We do not warrant that any of the materials are accurate, complete, or current. We may make changes to the materials at any time without notice.'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="Terms of Service"
        description="Terms of Service for Cemates.me. Read our terms and conditions for using our website and services."
        canonical="/terms"
        jsonLd={breadcrumbs.terms}
      />
      <div className="pt-32 pb-20">
        <div className="max-w-2xl mx-auto px-6">
          {/* Header */}
          <div className="mb-16">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-muted mb-6">
              <Scale className="w-5 h-5 text-foreground" />
            </div>
            <h1 className="text-3xl font-semibold text-foreground mb-3">
              Terms of Service
            </h1>
            <p className="text-muted-foreground text-sm">
              Last updated: April 27, 2024
            </p>
          </div>

          {/* Intro */}
          <div className="mb-12">
            <p className="text-muted-foreground leading-relaxed">
              Please read these Terms of Service carefully before using our website and services.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index}>
                <h2 className="text-lg font-medium text-foreground mb-4">
                  {section.title}
                </h2>
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {section.content}
                </p>
                {section.list && (
                  <div className="mt-4">
                    <p className="text-muted-foreground text-sm mb-3">{section.listPrefix}</p>
                    <ul className="space-y-2">
                      {section.list.map((item, itemIndex) => (
                        <li key={itemIndex} className="text-muted-foreground text-sm leading-relaxed flex gap-3">
                          <span className="text-muted-foreground/50 select-none">•</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};